import { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import CommonMessage from "../../common/CommonMessage";
import {GetAllTransactionHis } from "../../services/inventory";

import "ag-grid-community/styles/ag-theme-quartz.css";

const modules = [AllCommunityModule];

const TranHistory = () => {
    const [allRows, setAllRows] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadTransactions();
    }, []);

    const loadTransactions = async () => {
        try {
            setLoading(true);

            const response = await GetAllTransactionHis();

            if (response?.success && response?.statusCode === 200) {
                setAllRows(response.data || []);
                setError("");
            } else {
                setError(response?.message || "Failed to load transactions.");
            }
        } catch (err) {
            console.log(err);
            setError(err.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const columnDefs = useMemo(
        () => [
            {
                headerName: "ID",
                field: "id",
                width: 80,
                sortable: true,
                filter: true,
            },
            {
                headerName: "Product",
                field: "productName",
                width: 170,
                flex: 1.5,
                sortable: true,
                filter: true,
            },
            {
                headerName: "Transaction Type",
                field: "transactionType",
                width: 170,
                sortable: true,
                filter: true,
                cellStyle: (params) => {
                    if (params.value === "OpeningStock")
                        return {
                            color: "#0d6efd",
                            fontWeight: "bold",
                        };

                    if (params.value === "Purchase")
                        return {
                            color: "#198754",
                            fontWeight: "bold",
                        };

                    if (params.value === "Sale")
                        return {
                            color: "#dc3545",
                            fontWeight: "bold",
                        };

                    if (params.value === "Return")
                        return {
                            color: "#fd7e14",
                            fontWeight: "bold",
                        };

                    return null;
                },
            },
            {
                headerName: "Quantity",
                field: "quantity",
                width: 120,
                sortable: true,
            },
            {
                headerName: "Previous Stock",
                field: "previousStock",
                width: 150,
            },
            {
                headerName: "Current Stock",
                field: "currentStock",
                width: 150,
            },
            {
                headerName: "Reference No",
                field: "referenceNo",
                width: 170,
            },
            {
                headerName: "Remarks",
                field: "remarks",
                flex: 2,
                width: 270,
            },
           {
    headerName: "Transaction Date",
    field: "transactionDate",
    filter: "agDateColumnFilter",
    valueFormatter: (params) => {
        if (!params.value) return "";

        return new Date(params.value).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    },
    filterParams: {
        browserDatePicker: true,
        includeTime: false,      // Hide time picker
    },
}
        ],
        []
    );

    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: true,
            floatingFilter: true,
            resizable: true,
        }),
        []
    );

    return (
        <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Inventory Transaction History</h4>
            </div>

            {error && (
                <div className="mb-3">
                    <CommonMessage text={error} />
                </div>
            )}

            <div
                className="ag-theme-quartz"
                style={{
                    width: "100%",
                    minHeight: "500px",
                }}
            >
                <AgGridReact
                    modules={modules}
                    rowData={allRows}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={10}
                    paginationPageSizeSelector={[10, 20, 50, 100]}
                    animateRows={true}
                    rowHeight={45}
                    domLayout="autoHeight"
                    overlayLoadingTemplate={
                        '<span class="ag-overlay-loading-center">Loading...</span>'
                    }
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default TranHistory;